import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { RolActividad } from '@rpe/registro-personas-empresas-lib';
import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';

export const entityRolesActividadAdapter: EntityAdapter<RolActividad> =
  createEntityAdapter<RolActividad>({
    selectId: (model) => model.id,
    sortComparer: (a: RolActividad, b: RolActividad): number =>
      b.id.toString().localeCompare(a.id.toString())
  });

export interface EntityRolesActividadState extends EntityState<RolActividad> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityRolesActividadState =
  entityRolesActividadAdapter.getInitialState({
    isLoading: false,
    error: null
  });
